<div class="position-relative">
  <ng-container *ngFor="let additionalFile of uploadedAdditionalFiles; let i = index; let last = last">
    <document-upload-placeholder
      header="ADD_DOCUMENTS_FOR_ALL_ENTRIES"
      headerHint="ADD_DOCUMENTS_FOR_ALL_ENTRIES_HINT"
      isMultiple="true"
      isList="true"
      [isLast]="last"
      [existingFile]="additionalFile"
      [id]="'file-input-additional' + i"
      [validators]="validators"
      [allowedFileMimes]="allowedFileMimes"
      (remove)="onRemoveAdditionalFile(i)"
    ></document-upload-placeholder>
  </ng-container>

  <document-upload-placeholder
    header="ADD_DOCUMENTS_FOR_ALL_ENTRIES"
    headerHint="ADD_DOCUMENTS_FOR_ALL_ENTRIES_HINT"
    isMultiple="true"
    [id]="'file-input-multiple-first'"
    [validators]="validators"
    [allowedFileMimes]="allowedFileMimes"
    (uploadMultiple)="uploadFile($event)"
  ></document-upload-placeholder>

  <loading-spinner [show]="isUploadingDoc"></loading-spinner>
</div>
